import { ComponentProps } from 'react';
import { bordColorTheme } from '../../../../styles/styles.constants';

const BordEmployeeIcon = (props: ComponentProps<'svg'>) => {
  const { stroke } = props;
  return (
    <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="Icon-set/Employee">
        <path
          id="bg"
          d="M16 30.2858C23.8898 30.2858 30.2857 23.8899 30.2857 16.0001C30.2857 8.11029 23.8898 1.71436 16 1.71436C8.11023 1.71436 1.71429 8.11029 1.71429 16.0001C1.71429 23.8899 8.11023 30.2858 16 30.2858Z"
          fill="white"
          stroke={stroke || bordColorTheme.navyBlue[400]}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <g id="Vector">
          <path
            d="M16 17.3258C18.7605 17.3258 20.9984 15.088 20.9984 12.3275C20.9984 9.56693 18.7605 7.3291 16 7.3291C13.2395 7.3291 11.0017 9.56693 11.0017 12.3275C11.0017 15.088 13.2395 17.3258 16 17.3258Z"
            stroke={stroke || bordColorTheme.navyBlue[400]}
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M24.467 27.5076C22.0975 29.2539 19.1693 30.2859 16 30.2859C12.8307 30.2859 9.90252 29.2539 7.53308 27.5076C8.00494 25.7304 9.02561 24.1423 10.456 22.9732C12.0206 21.6943 13.9792 20.9957 16 20.9957C18.0208 20.9957 19.9794 21.6943 21.5441 22.9732C22.9744 24.1423 23.995 25.7304 24.467 27.5076Z"
            stroke={stroke || bordColorTheme.navyBlue[400]}
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </g>
      </g>
    </svg>
  );
};

export default BordEmployeeIcon;
